import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.link/o50a7n" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-300 group flex items-center justify-center" aria-label="Contact us on WhatsApp" data-id="element-172">
      <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75" data-id="element-173"></div>
      <MessageCircle size={32} className="relative z-10" data-id="element-174" />
      <span className="absolute right-full mr-4 bg-white text-gray-800 px-3 py-1 rounded-lg text-sm font-medium shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-175">
        ¡Escríbenos!
      </span>
    </a>;
}